<template>
	<v-app>
		<template v-if="isStandaloneRoute">
			<router-view key="standalone"></router-view>
		</template>
		<template v-else>
			<AppBar ref="appbar"></AppBar>
			<CircleNav />
			<NavigationDrawersV2></NavigationDrawersV2>
			<v-main>
				<router-view key="main"></router-view>
			</v-main>
		</template>
		<v-overlay :value="loading" class="cursor-wait z-index-level-4">
			<v-progress-circular indeterminate size="64"></v-progress-circular>
			<span v-if="loadingMessage">{{ loadingMessage }}</span>
		</v-overlay>
	</v-app>
</template>

<script>
import NavigationDrawersV2 from "./views/layout/NavigationDrawersV2.vue";
import { mapState } from "vuex";
import CircleNav from "@/views/layout/CircleNav";
import AppBar from "@/views/layout/AppBar";
import { checkForNewVersion } from "@/utils/checkVersion";

export default {
	name: "App",
	components: {
		AppBar,
		NavigationDrawersV2,
		CircleNav,
	},
	data() {
		return {
			versionCheckInterval: null,
		};
	},
	created() {
		this.$Progress.start();
	},
	watch: {},
	computed: {
		...mapState(["loading", "loadingMessage", "refCount"]),
		isStandaloneRoute() {
			return (
				this.currentUserInfo == null ||
				this.$route.meta.requiresAuth === false ||
				this.$route.path.includes("view-customer")
			);
		},
	},
	mounted() {
		if (!window.location.href.includes("localhost")) {
			window.addEventListener("load", () => {
				checkForNewVersion();
			});
			this.versionCheckInterval = setInterval(() => {
				checkForNewVersion();
			}, 600000);
		}
		this.$Progress.finish();
	},
	beforeDestroy() {
		clearInterval(this.versionCheckInterval);
	},
};
</script>
